export const Auth = () => {
    if (localStorage.getItem("token")) {
      let token = `Bearer ${JSON.parse(localStorage.getItem("token"))}`
      return token;
    } else {
      return null;
    }
  };
  